import React from "react";

const StringFormatter = ({value}) => {
    return (<span>{value.toString()}</span>)
}

export default StringFormatter;


// WEBPACK FOOTER //
// ./master/jsx/components/RMA/booleanFormatter.jsx